import moment from "moment-timezone";

// Given a date range, return a list of [start, end] gaps that are
// missing.
// All time-related args should be moment instances.
// times: An array of times.
// start: The starting date for gaps we are looking for. Pass
//    null for "latest".
// end: The ending date for gaps we are looking for. Pass null for
//    "latest". Ignored if start is null.
// data_interval: The fixed gap expected between record. moment.duration

function expected_gaps(times, { start, end, data_interval }) {
  if (times.length === 0) {
    // No times cached - it is all a gap!
    return [[start, end]];
  }

  const now = moment();
  if (start === null) {
    // This means "latest" - expect new times if it's been more than
    // data_interval since last time.
    if (moment.duration(now.diff(times[times.length - 1])) >= data_interval) {
      return [[now.clone().subtract(data_interval), now]];
    }
  }

  // Filter times down by what's in range.
  times = times.filter(t => t >= start);
  if (end !== null) {
    times = times.filter(t => t <= end);
  }

  if (times.length === 0) {
    // No times in range - it is all a gap!
    return [[start, end]];
  }

  // Find gaps.
  const sec = moment.duration(1, "s");
  const gaps = [];

  // Gap between start date and first time?
  if (moment.duration(times[0].diff(start)) > data_interval) {
    gaps.push([start, times[0].clone().subtract(data_interval)]);
  }

  // Find gaps within times.
  times.forEach((t, i, arr) => {
    if (i > 0) {
      const prev = arr[i - 1];
      if (moment.duration(t.diff(prev)) > data_interval) {
        gaps.push([prev.clone().add(sec), t.clone().subtract(sec)]);
      }
    }
  });

  // Gap between end date and last time?
  if (end === null) {
    if (moment.duration(now.diff(times[times.length - 1])) >= data_interval) {
      gaps.push([times[times.length - 1].clone().add(data_interval), null]);
    }
  } else {
    if (moment.duration(end.diff(times[times.length - 1])) >= data_interval) {
      gaps.push([times[times.length - 1].clone().add(data_interval), end]);
    }
  }

  return gaps;
}

export { expected_gaps };
